<template>
    <div>
        <ImageBoxTemplate :img="img">
            <div class="list-of-input  w-100">
            <div class="d-flex vertical-center mt-20px " v-for="(input, index) in listOfInput" :key="index">
                <div class="input-box-label pr-20px">{{ input.label }}</div>
                <div class="position-relative">
                    <input type="number" class="calculators-input-round w-100px" @input="$emit('update:modelValue', result)" v-model="result[input.label]" :min="0"/>
                    <div class="dollar-sign">$</div>
                </div>
            </div>
        </div>
        </ImageBoxTemplate>
</div>
</template>
<script>
import ImageBoxTemplate from '@/components/ImageBoxTemplate'
export default {
    data() {
        return {
            result: {

            }
        };
    },
    props: {
        listOfInput: Array,
        img: String,
        modelValue: Object
    },
    components:{
        ImageBoxTemplate
    },
    watch: {
        modelValue(newVal) {
            this.result = newVal;
        }
    }
};
</script>
<style scoped>
.input-box-container {
    position: relative;
    background-color: white;
    display: flex;
    justify-content: space-between;
    border-bottom-right-radius: 50px;
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
}
.w-100px{
    width:150px;
}
.list-of-input{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
}
.input-box {
    width: 100%;
    border: 3px solid var(--Secondary-Noir, #3B3B3C);
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
    padding: 22px 35px;
    color: var(--text-color);
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    box-sizing: border-box;
}
.dollar-sign{
    color:  #BAB1B1;
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right:40px;
}
.input-box-label {
    color: var(--text-color);
    font-family: var(--font);
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

@media screen and (max-width: 1300px) {

    .input-box-label {
        font-size: 30px;
        text-align: right !important;
        padding-bottom: 20px;
    }
}
@media screen and (max-width: 992px) {
    .dollar-sign{
        font-size: 25px;
    }
    .calculators-input-round{
        font-size: 20px;
        padding:15px 20px;
    }

}

@media screen and (max-width: 750px) {
  .w-100px{
        width:100%;
        box-sizing: border-box;
    }
}
@media screen and (max-width: 600px) {
  .calculators-input-round{
    width:200px;
    font-size: 20px;
    padding-left: 5px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .dollar-sign{
    right:25px;
    font-size: 25px;
  }
  .input-box-label {
        font-size: 20px;
        text-align: right !important;
        padding-bottom: 20px;
    }
}
@media screen and (max-width: 400px) {
    .calculators-input-round{
        width:120px;
    }
}
</style>